import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const AddIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM17 11.5C17.2761 11.5 17.5 11.7239 17.5 12C17.5 12.2455 17.3231 12.4496 17.0899 12.4919L17 12.5H12.5V17C12.5 17.2761 12.2761 17.5 12 17.5C11.7545 17.5 11.5504 17.3231 11.5081 17.0899L11.5 17V12.5H7C6.72386 12.5 6.5 12.2761 6.5 12C6.5 11.7545 6.67688 11.5504 6.91012 11.5081L7 11.5H11.5V7C11.5 6.72386 11.7239 6.5 12 6.5C12.2455 6.5 12.4496 6.67688 12.4919 6.91012L12.5 7V11.5H17Z'
        fill='currentColor'
      />
    </svg>
  );
};
